import { Box, makeStyles, Grid } from "@material-ui/core";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getBranchList } from "../../actions/commonAction";
import TopBar from "../../components/Common/TopBar";
import SearchSection from "../../components/SortingMachineManagement/SearchSection";
import SortingPlanDetail from "../../components/SortingMachineManagement/SortingPlanDetail";
import _ from 'lodash';
import { useState } from "react";
import CreateEditModal from "../../components/SortingMachineManagement/CreateEditModal";
import PresetDetail from "../../components/SortingMachineManagement/PresetDetail";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#3A3A3A',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        margin: 0
    },
    appBarClasses: {
        backgroundColor: '#3A3A3A',
        color: theme.palette.text.primary,
        padding: theme.spacing(1)
    }
}))

function SortingMachine() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation('sortingMachineManagement');

    const branchList = useSelector(state => state.common.branches);

    const [sortingCenters, setSortingCenters] = useState([]);

    useEffect(() => {
        if (branchList?.length > 0) {
            const sortingCenterList = _.map(branchList, (branch) => {
                if (branch.gt_warehouse) {
                    return branch;
                }
            });
            setSortingCenters(sortingCenterList)
        } else {
            dispatch(getBranchList());
        }
    }, [branchList])

    return (
        <Box className={classes.root}>
            <TopBar
                title={t('sorting_machine_management')}
                appBarClasses={classes.appBarClasses}
            />
            <Grid container style={{ padding: 24 }}>
                <Grid item xs={12}>
                    <SearchSection
                        sortingCenters={sortingCenters}
                    />
                </Grid>
                <Grid item xs={12}><PresetDetail /></Grid>
            </Grid>
            <CreateEditModal sortingCenters={sortingCenters} />
        </Box>
    );
}

export default SortingMachine;